module.exports = __webpack_public_path__ + "media/tgs-logo-animation.b1b72f21.mp4";